import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { User, Tenant } from 'types';
import { saveTokens } from 'utils/storage';

import { apiQuery } from '../../query';
import { getFullName } from '../../../utils/helpers';

import {
  UpdateTenantRequest,
  UpdateTenantResponse,
  ProfileTenantResponse,
  ProfileDetailsResponse,
} from './types';

const tagProfileType = 'PROFILE';
const tagTenantType = 'PROFILE_TENANT';

export const authApi = createApi({
  baseQuery: apiQuery,
  reducerPath: 'authApi',
  tagTypes: [tagProfileType, tagTenantType],
  endpoints: (build) => ({
    tenant: build.query<Tenant, void>({
      providesTags: [tagTenantType],
      transformResponse: (response: ProfileTenantResponse) => response.data,
      query: () => ({
        method: 'get',
        url: URL.PROFILE_TENANT_DETAILS,
      }),
    }),

    details: build.query<User & { fullName: string }, void>({
      providesTags: [tagProfileType],
      query: () => ({
        method: 'get',
        url: URL.PROFILE_DETAILS,
      }),
      transformResponse: (response: ProfileDetailsResponse) => {
        return {
          ...response.data,
          fullName: getFullName(
            response.data.firstName,
            response.data.lastName
          ),
        };
      },
    }),

    updateTenant: build.mutation<UpdateTenantResponse, UpdateTenantRequest>({
      query: (data) => ({
        data,
        method: 'patch',
        url: URL.PROFILE_TENANT_DETAILS,
      }),

      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const tokens = data.data;
          saveTokens(tokens);
        } catch (error) {
          console.error(error);
        }
      },
    }),
  }),
});

export const { useTenantQuery, useDetailsQuery, useUpdateTenantMutation } =
  authApi;
